// firebase.js
// contains the Firebase context and provider

import React, { createContext, useEffect } from 'react'
import {initializeApp,_apps} from 'firebase/app'
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"


// we create a React Context, for this to be accessible
// from a component later
const FirebaseContext = createContext(null)
export { FirebaseContext }
const config = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    // databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID
  };
  

export default ({ children }) => {
    let firebase = {
        database: null,
        analytics:null
    }

    // check if firebase app has been initialized previously
    // if not, initialize with the config we saved earlier
    if (!_apps.length) {
        const app = initializeApp(config)
        const db = getFirestore(app)
        const analyticsStart = getAnalytics(app);
        firebase = {
            database: db,
            analytics:analyticsStart
        }
    }

    return (
        <FirebaseContext.Provider value={firebase}>
            {children}
        </FirebaseContext.Provider>
    )
}